import React from 'react';

interface DurationBadgeProps {
    value: string;
}

export function DurationBadge({ value }: DurationBadgeProps) {
    if (value === 'on-going') {
        return (
            <span className="inline-flex items-center justify-center gap-1 px-2.5 py-px rounded-full text-[10px] leading-tight font-bold uppercase tracking-wider text-white bg-red-600 shadow-sm ring-1 ring-red-700/50 animate-pulse min-w-[88px]">
                <span className="relative flex h-1.5 w-1.5">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" />
                </span>
                on-going
            </span>
        );
    }
    return <>{value}</>;
}
